import { useState } from 'react';

import { GetTicketsModal } from '../../../../modals/GetTicketsModal/GetTicketsModal';

type Props = {
  isLoading: boolean;
};

export const GetTicketsButton = ({ isLoading }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const onClickHandler = () => {
    setIsModalOpen(true);
  };

  const onCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <GetTicketsModal open={isModalOpen} onOpenChange={setIsModalOpen} closeModal={onCloseModal} />
      {isLoading ? (
        <button className="skeleton-block w-full h-10" />
      ) : (
        <button
          onClick={onClickHandler}
          className="msq-btn msq-btn-lg msq-btn-primary w-full whitespace-nowrap"
        >
          Get Tickets
        </button>
      )}
    </>
  );
};
